import { render, staticRenderFns } from "./vector-group.component.vue?vue&type=template&id=c52a2a26&scoped=true&"
import script from "./vector-group.component.vue?vue&type=script&lang=js&"
export * from "./vector-group.component.vue?vue&type=script&lang=js&"
import style0 from "./vector-group.component.vue?vue&type=style&index=0&id=c52a2a26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a2a26",
  null
  
)

export default component.exports